import $ from "jquery";
import qs from "query-string";
import Backbone from "backbone";
import Marionette from "backbone.marionette";
import AnimatedRegion from "marionette-animated-region";

import component from "../components";
import positionModels from "../models/positions";

import template from "../templates/candidate/suggestions.jst";

export function loadSuggestions(params = {}) {
    return $.ajax({
        type: "GET",
        url: `/api/hire/v1/suggestion/?${qs.stringify(params)}`,
        dataType: "json",
        contentType: "application/json",
    });
}

export function saveSuggestion({
    accepted,
    appPositions,
    index,
    group,
    source,
    feature,
    positionID,
    positions = [],
}) {
    if (positions.length === 0) {
        positions.push({
            id: positionID,
            accepted,
            index,
            group,
            source,
            feature,
            app_positions: appPositions,
        });
    }

    return $.ajax({
        url: "/api/hire/v1/suggestion/",
        method: "POST",
        data: JSON.stringify({
            positions,
        }),
        dataType: "json",
        contentType: "application/json",
    });
}

export default Marionette.View.extend({
    MAX_SUGGESTIONS: 10,
    MAX_APPROVED: 3,

    template,
    ui: {
        buttons: ".suggestions__buttons",
        applyButton: ".suggestions__apply",
    },
    events: {
        "click .suggestions__pass": "onPass",
        "click .suggestions__approve": "onApprove",
        "click .suggestions__undo": "onUndo",
        "click @ui.applyButton": "onApply",
    },
    regions: {
        suggestions: {
            selector: ".suggestions__card",
            regionClass: AnimatedRegion,
            animation: {
                showAnimation: [
                    {
                        properties: "transition.slideRightBigIn",
                    },
                ],
                hideAnimation: [
                    {
                        properties: "transition.slideLeftBigOut",
                    },
                ],
            },
        },
    },
    initialize() {
        this.similar = this.options.positions;
        this.approved = [];
        this.current = 0;
        this.maxApproved = this.options.maxApproved || this.MAX_APPROVED;

        this.onDetailBack = this.onDetailBack.bind(this);
        this.onDetailShow = this.onDetailShow.bind(this);
        this.onPopState = this.onPopState.bind(this);
        this.onRegionShown = this.onRegionShown.bind(this);
    },
    serializeData() {
        return {
            showNav: !!this.options.showNav,
            count: Math.min(this.MAX_SUGGESTIONS, this.similar.length),
        };
    },
    onRender() {
        Backbone.Radio.channel("region").on("region:shown", this.onRegionShown);

        const $body = $("body");
        $body.on("click", ".back", this.onDetailBack);
        $body.on("click", ".js-job-detail", this.onDetailShow);

        this.showSuggestion(0);
    },
    onRegionShown(region) {
        // animated region's transforms mess up position: fixed elements
        region.$el.css("transform", "none");
        this.ui.buttons.fadeIn(100);
    },
    onDetailShow() {
        this.detailShown = true;
        $(".suggestions__root").addClass("suggestions__root--details");
    },
    onDetailBack() {
        this.detailShown = false;
        $(".suggestions__root").removeClass("suggestions__root--details");
    },
    onPopState() {
        $(window).off("popstate", this.onPopState);
        this.showSuggestion(this.current);
    },
    showSuggestion(index) {
        this.current = index;

        if (this.detailShown) {
            // Yay async operations. We need to wait for the popstate to happen because
            // we need the URL and querystring to NOT be the job detail URL
            $(window).on("popstate", this.onPopState);
            this.onDetailBack();
            window.goBack(true);
            return;
        }

        if (
            this.approved.length >= this.maxApproved ||
            index >= Math.min(this.MAX_SUGGESTIONS, this.similar.length)
        ) {
            this.finishStep();
            return;
        }

        this.card = new component.JobCard({
            model: new positionModels.Position(this.similar[index]),
            approvedText: "Saved",
        });
        this.showChildView("suggestions", this.card);
    },
    finishStep() {
        this.trigger("suggest:finish", this.approved, this.current);
    },
    onApprove(event) {
        event.preventDefault();

        this.saveSuggestion(true);

        const position = this.similar[this.current];
        this.approved.push(position.id);
        this.trigger("suggest:approve", position);

        this.card.showAdded(() => {
            this.showSuggestion(this.current + 1);
        });
    },
    onPass(event) {
        event.preventDefault();

        this.saveSuggestion(false);

        const position = this.similar[this.current];
        this.trigger("suggest:pass", position);

        this.showSuggestion(this.current + 1);
    },
    onUndo(event) {
        event.preventDefault();

        const last = this.current - 1;
        if (last < 0) {
            return;
        }

        const position = this.similar[last];
        if (!position.suggestionID) {
            return;
        }

        $.ajax({
            url: `/api/hire/v1/suggestion/${position.suggestionID}/`,
            method: "DELETE",
            dataType: "json",
            contentType: "application/json",
        }).done(() => {
            if (position.accepted) {
                this.approved = this.approved.filter((pid) => pid !== position.id);
            }
            this.trigger("suggest:undo", position);
            this.showSuggestion(last);
        });
    },
    onApply(event) {
        event.preventDefault();

        if (this.applying) {
            return;
        }

        const positionID = this.similar[this.current].id;
        const params = {
            sn: 0,
            p: positionID,
        };

        if (this.options.utm_medium) {
            params.utm_medium = this.options.utm_medium;
        }

        this.applying = true;
        this.ui.applyButton.addClass("circle-loader").removeClass("tooltip");

        this.saveSuggestion(true).always(() => {
            setTimeout(() => {
                window.location.href = `/app/start/?${qs.stringify(params)}`;
            }, 0);
        });
    },
    saveSuggestion(accepted) {
        const position = this.similar[this.current];

        return saveSuggestion({
            accepted,
            index: this.current,
            group: this.options.group,
            source: this.options.source,
            appPositions: this.options.appPositions,
            feature: position.suggestion_feature,
            positionID: position.id,
        }).done(([id]) => {
            position.suggestionID = id;
            position.accepted = accepted;
        });
    },
});
